import { gql } from '@apollo/client';

export const ALL_EMAIL_TEMPLATES_QUERY_NAME = 'AllEmailTemplates';
export const ALL_EMAIL_TEMPLATES = gql`
    query ${ALL_EMAIL_TEMPLATES_QUERY_NAME}(
        $page: Int,
        $perPage: Int,
        $sortKey: String,
        $sortDirection: String,
    ) {
        allEmailTemplates(
            page: $page,
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
        ) {
            availableProductTypes
            availableProducts {
                id
                productId
                name
                productType
                isinCode
                iconSymbol
                iconColor
            }
            emailTemplateList {
                totalCount
                models {
                    id
                    name
                    productId
                    recipients
                    recipientsCc
                    recipientsBcc
                    subject
                    body
                    phases
                    locale
                }
            }
        }
    }
`;

export const CREATE_EMAIL_TEMPLATE = gql`
    mutation CreateEmailTemplate(
        $productId: Int!,
        $phases: [AuctionPhase!]!,
        $locale: String!,
        $name: String!,
        $recipients: String!,
        $recipientsCc: String,
        $recipientsBcc: String,
        $subject: String!,
        $body: String!,
        $correlationId: String!
    ) {
        createEmailTemplate(
            productId: $productId,
            phases: $phases,
            locale: $locale,
            name: $name,
            recipients: $recipients,
            recipientsCc: $recipientsCc,
            recipientsBcc: $recipientsBcc,
            subject: $subject,
            body: $body,
            correlationId: $correlationId
        ) {
            id
            name
        }
    }
`;

export const UPDATE_EMAIL_TEMPLATE = gql`
    mutation UpdateEmailTemplate(
        $id: Int!,
        $productId: Int!,
        $phases: [AuctionPhase!]!,
        $locale: String!,
        $name: String!,
        $recipients: String!,
        $recipientsCc: String,
        $recipientsBcc: String,
        $subject: String,
        $body: String!,
        $correlationId: String!
    ) {
        updateEmailTemplate(
            id: $id,
            productId: $productId,
            phases: $phases,
            locale: $locale,
            name: $name,
            recipients: $recipients,
            recipientsCc: $recipientsCc,
            recipientsBcc: $recipientsBcc,
            subject: $subject,
            body: $body,
            correlationId: $correlationId
        ) {
            id
            name
        }
    }
`;

export const DELETE_EMAIL_TEMPLATE = gql`
    mutation DeleteEmailTemplate(
        $id: Int!,
        $correlationId: String!
    ) {
        deleteEmailTemplate(
            id: $id,
            correlationId: $correlationId
        ) {
            id
            name
        }
    }
`;

export const ON_EMAIL_TEMPLATE_CHANGED = gql`
    subscription onEmailTemplateChanged {
        emailTemplateChanged {
            correlationId
            action
            model {
                id
                name
            }
        }
    }
`;

export const EXISTS_EMAIL_TEMPLATE_QUERY_NAME = 'ExistsEmailTemplate';
export const EXISTS_EMAIL_TEMPLATE = gql`
    query ${EXISTS_EMAIL_TEMPLATE_QUERY_NAME}($name: String!) {
        existsByName(name: $name)
    }
`;
